"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = placeholder;

var _styledComponents = require("styled-components");

function placeholder() {
  var styles = _styledComponents.css.apply(void 0, arguments);

  return (0, _styledComponents.css)(["&::placeholder{", "}&::-webkit-input-placeholder{", "}&::-moz-placeholder{", "}&:-ms-input-placeholder{", "}"], styles, styles, styles, styles);
}